var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":'#'+ _vm.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d00cfac0","hasScoped":false,"buble":{"transforms":{}}}!./resources/assets/front/js/components/vgb-icon/template.html
// module id = 192
// module chunks = 14